export const BOT_WIZARD_ENDED = 'BOT_WIZARD_ENDED'

export const BOT_WIZARD_CLOSED = 'BOT_WIZARD_CLOSED'
export const APPOINTMENT_TIME_SELECTED = 'APPOINTMENT_TIME_SELECTED'
export const SHOW_NO_AVALIBILITY = 'SHOW_NO_AVALIBILITY'
export const APPOINTMENT_APPROVAL_ENDED = 'APPOINTMENT_APPROVAL_ENDED'
export const PENDING_APPOINTMENT_FOUND = 'PENDING_APPOINTMENT_FOUND'
export const HTN_BOT_STARTED = 'HTN_BOT_STARTED'
export const MENTALHEALTH_BOT_STARTED = 'MENTALHEALTH_BOT_STARTED'
export const DIABETES_BOT_STARTED = 'DIABETES_BOT_STARTED'
export const SHOW_FAMILY_MEMBERS_REQUESTED = 'SHOW_FAMILY_MEMBERS_REQUESTED'
export const SHOW_FAMILY_MEMBERS_RECEIVED = 'SHOW_FAMILY_MEMBERS_RECEIVED'
export const DOCTOR_SELECTED = 'DOCTOR_SELECTED'
export const SHOW_MORE_TIME_OPTIONS_ERROR = 'SHOW_MORE_TIME_OPTIONS_ERROR'
export const TERMINATE_BOT_POPUP = 'TERMINATE_BOT_POPUP'
export const TERMINATE_RISK_ASSESSMENT_POPUP = 'TERMINATE_RISK_ASSESSMENT_POPUP'
export const FIND_A_PROVIDER_CLICKED = 'FIND_A_PROVIDER_CLICKED'

export const INITIATE_CONNECTIVITY_TEST = 'INITIATE_CONNECTIVITY_TEST'
export const END_CONNECTIVITY_TEST = 'END_CONNECTIVITY_TEST'

// TODO - do we need it??
export const SHOW_INVITE_FAMILY_MEMBER_CHOSEN =
  'SHOW_INVITE_FAMILY_MEMBER_CHOSEN'
export const SHOW_INVITE_FAMILY_LIST = 'SHOW_INVITE_FAMILY_LIST'
export const PENDING_APPOINTMENT_REFERRED_CREATED =
  'PENDING_APPOINTMENT_REFERRED_CREATED'
export const UPLOAD_FILE_CANCELED = 'UPLOAD_FILE_CANCELED'
export const UPLOAD_FILE_FAILED = 'UPLOAD_FILE_FAILED'
export const SHOW_UPLOAD_ID_COMPONENT_REQUESTED =
  'SHOW_UPLOAD_ID_COMPONENT_REQUESTED'
export const SHOW_ID_UPLOADED_REQUESTED = 'SHOW_ID_UPLOADED_REQUESTED'
export const SHOW_RESCHEDULE_APPOINTMENT = 'SHOW_RESCHEDULE_APPOINTMENT'
export const ASK_TO_START_CLINIC = 'ASK_TO_START_CLINIC'
export const START_CLINIC_ABORTED = 'START_CLINIC_ABORTED'
export const GET_CLINIC_INIT = 'GET_CLINIC_INIT'
export const SELECTED_APPOINTMENT_CHANGED = 'SELECTED_APPOINTMENT_CHANGED'
export const WIZARD_ENDED = 'WIZARD_ENDED'
export const NAV_TO_APPT_BEFORE_VISIT_FROM_NOTIFICATION =
  'NAV_TO_APPT_BEFORE_VISIT_FROM_NOTIFICATION'
export const NAV_TO_MEDICAL_NOTE_FROM_NOTIFICATION =
  'NAV_TO_MEDICAL_NOTE_FROM_NOTIFICATION'
export const NAVIGATE_TO_PRESCRIPTION = 'NAVIGATE_TO_PRESCRIPTION'
export const NAV_TO_REFERRAL_RESULT_FROM_NOTIFICATIONS =
  'NAV_TO_REFERRAL_RESULT_FROM_NOTIFICATIONS'
export const NAV_TO_REFERRAL_RESULT = 'NAV_TO_REFERRAL_RESULT'
export const NAV_TO_CLINIC_REFERRAL = 'NAV_TO_CLINIC_REFERRAL'
export const HMO_PAYMENT_ALERT = 'HMO_PAYMENT_ALERT'

export const SCHEDULE_PCP = 'SCHEDULE_PCP'
export const SCHEDULE_ANY_PCP = 'SCHEDULE_ANY_PCP'

export const BOT_CONCENT_STATUS_CHANGED = 'BOT_CONCENT_STATUS_CHANGED'
